import React, { useState, useEffect, useContext } from 'react'
import { NavigationContext } from '../NavigationContext'

function SinglePublication() {
  const [publication, setPublication] = useState(null)
  const [loading, setLoading] = useState(true)
  const { currentSlug } = useContext(NavigationContext)

  useEffect(() => {
    const fetchPublication = async () => {
      const publicationSlug = currentSlug.replace('publikationen/', '')
      console.log('Fetching slug:', publicationSlug) // Debug log
      
      try {
        const response = await fetch(`/wp-json/wp/v2/publikationen?slug=${publicationSlug}&_embed`)
        const data = await response.json()
        console.log('API response:', data) // Debug log
        
        if (data.length > 0) {
          const pub = data[0]
          setPublication({
            title: pub.title.rendered,
            content: pub.content.rendered,
            featuredImage: pub._embedded?.['wp:featuredmedia']?.[0]?.source_url,
            date: new Date(pub.date).toLocaleDateString(),
            externalLink: pub.acf?.external_link_pub || ''
          })
        }
        setLoading(false)
      } catch (error) {
        console.error('Error:', error)
        setLoading(false)
      }
    }

    fetchPublication()
  }, [currentSlug])

  if (loading) return <div className="loading">Loading...</div>
  if (!publication) return <div>Publication not found</div>

  return (
    <article className="single-publication">
      <header className="page-header">
        <h1 className="page-title">
          <span className="main-title">Publikationen</span>
          <span className="subtitle">: <em>{publication.title}</em></span>
        </h1>
      </header>

      <div className="publication-grid">
        {publication.featuredImage && (
          <div className="publication-featured-image">
            <img src={publication.featuredImage} alt={publication.title} />
          </div>
        )}

        <div className="publication-content-wrapper">
          <div 
            className="publication-content"
            dangerouslySetInnerHTML={{ __html: publication.content }}
          />
        </div>
      </div>

      {publication.externalLink && (
        <div className="external-link-section">
          <hr />
          <a href={publication.externalLink} target="_blank" rel="noopener noreferrer">
            Link zur Website ↪
          </a>
        </div>
      )}
    </article>
  )
}

export default SinglePublication